import { useState, useEffect, useContext } from "react"
import { Link, useParams } from "react-router-dom"
import { client } from "../client"
import { PortableText } from "@portabletext/react"
import Footer from "../components/Footer"
import { CursorContext } from '../context/CursorContext';
import { useTheme } from '../context/ThemeContext';


export default function SinglePost() {
  const [singlePost, setSinglePost] = useState([])
  const { slug } = useParams()
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);
  const theme = useTheme();
  const darkMode = theme?.darkMode ?? true;

  useEffect(() => {
    client
      .fetch(
        `*[slug.current == "${slug}"] {
        title,
        body,
        mainImage {
          asset -> {
            _id,
            url
          },
          alt,
        }, 
        "name": author -> name,
      } | order(publishedAt desc)`
      )
      .then((data) => setSinglePost(data[0]))
  }, [slug])

  return (
    <>
      <main
        style={{
          background: darkMode
            ? 'linear-gradient(to top right, #1e1b4b, #020617, #000000)'
            : '#ffffff',
          color: darkMode ? '#ffffff' : '#0f172a',
          transition: 'all 0.3s ease',
        }}
        className="min-h-screen overflow-y-auto"
      >
        <article className="h-full max-w-full flex flex-col px-6 items-center md:m-auto md:w-[70rem]">

          {/* title */}
          <h1 className={`h1 sm:text-7xl items-center font-bold my-14 text-center ${darkMode ? 'text-white' : 'text-slate-900'}`}>
            {singlePost.title}
          </h1>

          {singlePost.mainImage && singlePost.mainImage.asset && (
            <img
              className="lg:blog__image rounded-t"
              src={singlePost.mainImage.asset.url}
              alt={singlePost.title}
              title={singlePost.title}
              loading="lazy"
            />
          )}

          <div className="block__content w-full">
            <p className={`mt-5 text-xs font-secondary tracking-widest uppercase ${darkMode ? 'text-white/30' : 'text-slate-400'}`}>
              By {singlePost.name}
            </p>

            {singlePost.body && (
              <div className="mt-5 space-y-4 md:w-[45rem] lg:w-[64rem]">
                <PortableText value={singlePost.body} />
              </div>
            )}

            <Link
              onMouseEnter={mouseEnterHandler}
              onMouseLeave={mouseLeaveHandler}
              to="/blog"
              className={`mt-10 inline-block py-2 px-6 rounded shadow border-2 font-bold transition-all duration-500 ${
                darkMode
                  ? 'text-white bg-black hover:bg-white border-slate-200 hover:text-black'
                  : 'text-slate-900 bg-white hover:bg-slate-900 border-slate-900 hover:text-white'
              }`}
            >
              Read more articles
            </Link>
          </div>

          {/* hire me link */}
          <Link
            to='/contact'
            onMouseEnter={mouseEnterHandler}
            onMouseLeave={mouseLeaveHandler}
            className='rounded mb-[30px] py-2 my-20 mx-auto lg:mx-auto w-fit px-10 flex items-center bg-sky-900 cursor-pointer text-white'
          >
            HIRE ME
          </Link>

        </article>
        <Footer />
      </main>
    </>
  );
}